import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

interface FaIconProps {
	weight?: string,
	icon: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FaIcon',
  props: {
    weight: { default: 'r' },
    icon: {}
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => `fa${props.weight} fa-${props.icon}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(className.value),
    "aria-hidden": "true"
  }, null, 2))
}
}

})